import React, { FC } from 'react';
import { Form, Input } from 'antd';

const { Search } = Input;

type Props = {
  label: string;
  maxWidth?: string;
  onChange: (value: string) => void;
};

export const SearchText: FC<Props> = ({ label, maxWidth, onChange }) => {
  return (
    <Form.Item label={label} colon={false}>
      <Search style={{ minWidth: '150px', maxWidth: maxWidth ? maxWidth : '200px' }} allowClear={true} onSearch={onChange} />
    </Form.Item>
  );
};

export default SearchText;
